import {TweenLite, TimelineLite} from "gsap";
import {random} from "./random";

export function shake(element: any, strength: number, shakes: number, duration: number, rotate: boolean = false){
    const tl = new TimelineLite();

    TweenLite.set(element, { x: "+=0" });

    const transforms = element._gsTransform;
    const initProps = {
        x: transforms.x,
        y: transforms.y,
        rotation: transforms.rotation
    };

    for (let i = 0; i < shakes; i++){
        tl.to(element, duration / shakes, {
            x: initProps.x + random(-strength, strength),
            y: initProps.y + random(-strength / 2, strength / 2),
            ...(rotate
                ? {rotation: initProps.rotation + random(-strength, strength)}
                : undefined
            )
        });
    }

    tl.to(element, duration / shakes ,{
        x: initProps.x,
        y: initProps.y,
        rotation: initProps.rotation
    });

    return tl;
}

export function shakeScale(element: any, strength: number, shakes: number, duration: number, delay: number = 0){
    const tl = new TimelineLite({delay: delay});

    for (let i = 0; i < shakes; i++){
        tl.to(element, duration / shakes, {
            scaleX: 1 + random(-strength, strength),
            scaleY: 1 + random(-strength, strength),
        });
    }

    tl.to(element, duration / shakes ,{
        scaleX: 1,
        scaleY: 1,
    });

    return tl;
}